import Modal from './modal.js';


$(document).ready(function() {

    $(document).on('click', '.delete-guest-btn', function(e) {
        e.preventDefault();

        Modal.openModal('.modal-delete-guest');

    });

});



// WEBPACK FOOTER //
// ./guests.js